<template>
  <div class="home-box">
    <div class="home-bg" id="indexMap">
      <img class="map_bg" src="@/assets/home_images/home_bg.jpg">
      <div class="point"
        v-for="(marker, index) in markers"
        :key="index"
        @click="markerClick(marker)"
        :style="'margin-left:'+Number(marker.longitude)+'px;margin-top:'+Number(marker.latitude)+'px'"
      ><img :src=" require('../../assets/home_images/home_point1.png')">
      </div>

      <div 
          class="alert_item"
          :style="'margin-left:'+Number(currentWindow.longitude)+'px;margin-top:'+Number(currentWindow.latitude)+'px'"
          v-if="currentWindow.visible"
        >
        <div
          class="item_map"
        >
          <div class="close-window" @click="closeWin()">
            <i class="el-icon-close"></i>  
          </div>
          <h3 class="info-title" :title="lampInfo.name">
            {{ lampInfo.name }}
          </h3>
          <div class="info-content">
            <div v-html="getValueHtml(lampInfo)"></div>
          </div>
          <div class="info-controls">
            <button
              class="btn-lamp-control"
              data-text="路灯控制"
              @click="$router.push('/light/lightList')"
            ></button>
          </div>
        </div>
      </div>

    </div>
    <div class="head">
      <div class="head-bg">
        <div class="head-l"></div>
        <div class="head-c"><h1><img src="@/assets/home_images/logo.png" />{{$store.state.user.title}}</h1></div>
        <div class="head-r"></div>
      </div>
    </div>
    <div class="go-system" @click="$router.push('/light/lightList')">
      <img src="@/assets/home_images/go_system.png" />
    </div>
    <div class="left-top"><img src="@/assets/home_images/left_top.png" /></div>
    <div class="right-top">
      <img src="@/assets/home_images/right_top.png" />
    </div>
    <div class="home-left">
      <div class="home_pad">
        <div class="main-left-top"><box1 :itemData="resData.lamp"></box1></div>
        <div class="main-left-cen">
          <!-- <box2 :itemData="resData.camera" :accessToken="accessToken"></box2> -->
          <img src="@/assets/home_images/video.png" />
        </div>
      </div>
    </div>
    <div class="home-right">
      <div class="home_pad">
        <div class="main-right-cen"><box4 :itemData="resData.ip"></box4></div>
        <div class="main-right-cen">
          <box6 :itemData="resData.one_key"></box6>
        </div>
        <div class="main-right-bot">
          <box7 :itemData="resData.alarm"></box7>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import homeApi from "@/api/home/index";
import lightListApi from "@/api/light/lightList";
import box1 from "@/components/home/box1.vue";
import box7 from "@/components/home/box7.vue";

import store from "@/store";
export default {
  components: {
    box1,
    box7,
  },
  data() {
    return {
      resData: {
        lamp: {
          total: 0,
          online: 0,
          malfunction: 0,
          lamp_light: 0,
          light: 1,
          voltage: 220,
          current: 1,
          power: 220,
          lamp_id: 2,
          colorTemperature: 25,
          cost_electricity: 100,
          total_electricity: 2645.5,
          save_electricity: 2568.06,
          name: '默认灯杆',
          Power_factor: 0.0000039
        }
      },
      markers: [],
      currentWindow:{
        longitude: 0,
        latitude: 0,
        visible: false
      },
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: ""
      },
      timer: null
    };
  },
  methods: {

    getData() {
      //获得首页数据
      homeApi.homeData().then((res) => {
        if (res.data.code === 1000) {
          this.resData = res.data.data;
        }
      });
    },

    getLampList() {
      //获得地图标记
      lightListApi
        .lightList({
          page: 1,
          pageSize: 500,
        })
        .then((res) => {
          if (res.data.code === 1000) {
            this.markers = res.data.data.list
          }
        });
    },

    getValueHtml(item) {
      let str= '';
      // str+= '设备识别号：<span>'+item.number+'</span><br/>';
      str+= '当前策略：<span>'+item.stg_name+'</span><br/>';
      str+= '电流(A)：<span>'+item.current+'</span><br/>';
      str+= '电压(V)：<span>'+item.voltage+'</span><br/>';
      str+= '亮度(%)：<span>'+item.light+'</span><br/>';
      return str;
    },
    markerClick(marker) {
      this.lampInfo = marker;
      console.log('this.lampInfo',this.lampInfo)
      this.currentWindow.longitude = Number(marker.longitude)
      this.currentWindow.latitude = Number(marker.latitude)
      this.currentWindow.visible = true
    },
    closeWin() {
      this.currentWindow.visible = false;
      this.currentWindow.longitude = 0;
      this.currentWindow.latitude = 0;
      this.videoData.dialogVisible = false;
    }
  },
  mounted() {
    this.getLampList();
    // 下面为制作定时器（首页模块数据）
    this.getData();
    if (this.timer) {
      clearInterval(this.timer);
    } else {
      this.timer = setInterval(() => {
        setTimeout(this.getData(), 0);
      }, 6 * 1000);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style lang='less'>
.home-box {
  position: relative;
  width: 100%;
  height: 100%;
  background: #171732;
  .home-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    background: #171732;
    img.map_bg {
      width: 100%;
      height: auto;
      position: absolute;
      left:50%;
      top:50%;
      transform:translate(-50%,-50%);
      z-index: 0;
    }
    .point{
      position: absolute;
      left:50%;
      top:50%;
      cursor: pointer;
      z-index: 1;
      img{
        width:22px;
        height:auto;
        // transform:translate(-50%,-50%);
      }
    }
  }
  .head {
    position: absolute;
    width: 50%;
    height: 122px;
    left: 25%;
    top: 0;
    z-index: 2;
    display: flex;
    justify-content: center;
    background: url("../../assets/home_images/head_bg.png") center top no-repeat;
    .head-bg {
      height: 74px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .head-l {
      width: 74px;
      height: 74px;
      background: url("../../assets/home_images/head_l.png") no-repeat;
    }
    .head-c {
      width: auto;
      height: 74px;
      background: url("../../assets/home_images/head_c.png") 0 0 repeat-x;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      h1 {
        font-size: 32px;
        color: #fff;
        height: 74px;
        width:100%;
        font-weight: normal;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          margin-right: 10px;
          height:50px;
        }
      }
    }
    .head-r {
      width: 74px;
      height: 74px;
      background: url("../../assets/home_images/head_r.png") no-repeat;
    }
  }
  .go-system {
    position: absolute;
    width: 150px;
    right: 35px;
    top: 22px;
    z-index: 999;
    cursor: pointer;
    text-align: right;
    img {
      width: auto;
      height: 26px;
    }
  }
  .home-left {
    position: absolute;
    width: 32%;
    height: 100%;
    left: 0;
    top: 0;
    background: linear-gradient(
      to right,
      rgba(13, 19, 33, 1) 0,
      rgba(13, 19, 33, 0.75) 75%,
      transparent 100%
    );
    z-index: 9;
    .home_pad {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 80px;
      padding-left: 30px;
      position: relative;
      overflow: hidden;
      .main-left-top {
        width: 75%;
        padding: 20px 0;
        height: 30%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-left-cen {
        width: 75%;
        padding: 20px 0;
        height: 40%;
        box-sizing: border-box;
        overflow: hidden;
      }
      .main-left-bot {
        padding: 20px 0;
        height: 30%;
        box-sizing: border-box;
      }
    }
  }
  .home-right {
    position: absolute;
    width: 28%;
    height: 100%;
    right: 0;
    top: 0;
    background: linear-gradient(
      to left,
      rgba(13, 19, 33, 1) 0,
      rgba(13, 19, 33, 0.8) 65%,
      transparent 100%
    );
    z-index: 9;
    .home_pad {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-top: 80px;
      padding-right: 30px;
      position: relative;
      overflow-y: hidden;
      background: url("../../assets/home_images/right_bottom.png") right bottom
        no-repeat;
      .main-right-cen {
        padding: 20px 0;
        height: 30%;
        width: 85%;
        box-sizing: border-box;
        float: right;
      }
      .main-right-bot {
        padding: 20px 0;
        width: 100%;
        height: 40%;
        box-sizing: border-box;
        float: right;
      }
    }
  }
  .left-top,
  .right-top {
    position: absolute;
    width: 19.94%;
    left: 0;
    top: 0;
    z-index: 10;
    img {
      width: 100%;
      height: auto;
    }
  }
  .right-top {
    width: 23.489%;
    left: auto;
    right: 0;
  }

  .index-demo {
    width: 100%;
    height: 100%;
  }

  .amap-logo {
    display: none !important;
    opacity: 0 !important;
  }
  .amap-layers {
    background: #191936 !important;
  }
  .alert_item{
    position: absolute;
    left: 50%;
    top: 50%;
    width:200px;
    z-index: 9999;
  }
  .item_map {
    background-image: url("../../assets/home_images/item_map.png");
    background-position: 0 0;
    background-size: 100% 100%;
    padding: 20px;
    border-radius: 20px;
    border: 2px solid #ff7bac;
    position: relative;
    width: 200px;
    margin-left: -89px;
    margin-top: -254px;
    box-sizing: border-box;
    height:260px;
    color: #fff;
    .close-window {
      width: 26px;
      height: 26px;
      border-radius: 26px;
      cursor: pointer;
      background: #2e3192;
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中 */
      position: absolute;
      top: 10px;
      right: 10px;
      color: #fff;
      i {
        color: #fff;
        font-size: 18px;
      }
    }
    .close-window:hover {
      background: #373bac;
    }
    h3.info-title {
      margin: 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 20px;
    }
    .info-content {
      margin: 5px 0;
      overflow: hidden;
      font-size: 13px;
      height:100px;
      line-height: 1.6;
    }
    .info-controls {
      overflow-x: auto;
      overflow-y: hidden;
      margin-top: 10px;
      outline: none;
    }
    .info-controls button {
      border: 1px solid #fff;
      border-radius: 50%;
      background-size: 26px;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #282c5e;
      position: relative;
      width: 50px;
      height: 50px;
      line-height: 1.2em;
      margin: 0 15px 25px 0;
      box-sizing: border-box;
      cursor: pointer;
      float: left;
      outline: none;
      color: #fff;
    }
    .info-controls button:after {
      content: attr(data-text);
      display: inline-block;
      font-size: 12px;
      position: absolute;
      top: 55px;
      left: 0;
      right: 0;
      text-align: center;
    }
    .info-controls button.btn-lamp-control {
      background-image: url(../../assets/svg/lamp-control2.svg);
    }
    .info-controls button.btn-video-preview {
      background-image: url(../../assets/svg/video-preview2.svg);
    }
  }
  .item_map:after {
    position: absolute;
    content: "";
    z-index: -1;
    bottom: -8px;
    left: 50%;
    margin-left: -8px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #ff7bac;
  }
}
</style>